import * as moment from "moment";

export const filters = [
 
  {
    filterName: "Anno Giro",
    filterData: getFilterYears(),
    selected: new Date().getFullYear(),
  },
  {
    filterName: "Numero Giro",
    filterData: [
      {
        id: 0,
        value: "tutti",
      },
      {
        id: 1,
        value: "giro n.1",
      },
      {
        id: 2,
        value: "giro n.2",
      },
      {
        id: 3,
        value: "giro n.3",
      },
      {
        id: 4,
        value: "giro n.4",
      },
      {
        id: 5,
        value: "giro n.5",
      },
      {
        id: 6,
        value: "giro n.6",
      },
      {
        id: 7,
        value: "giro n.7",
      },
    ],
    selected: 0,
  }, 
   {
    filterName: "Stato",
    filterData: [
      {
        id: "0",
        value: "tutti",
      },
      {
        id: "1",
        value: "Novità da pubblicare",
      },
      {
        id: "2",
        value: "Novità scadute",
      },
       {
        id: "3",
        value: "Ristampe",
      },
      {
        id: "4",
        value: "Pubblicati",
      },
    ],
    selected: "0"

  },
];

function getFilterYears() {
  const firstYear = 2012;
  const currentYear = moment().year();

  let years = [
    {
      id: 0,
      value: "tutti",
    },
  ];

  for (let i = currentYear + 1; i >= firstYear; i--) {
    years.push({
      id: i,
      value: i.toString(),
    });
  }

  return years;
}
